<template>
  <aha-button variant="success" @click="openUpgrade()">
    {{ $i18nPresenter.t('Upgrade now') }}
  </aha-button>
</template>

<script>

export default {
  methods: {
    openUpgrade() {
      // add redirect to handle case: guest clicks upgrade -> go to sign-up first
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

</style>
